define('core/extensions/helpers/html',[
    'handlebars',
], function (
    Handlebars
) {
    'use strict';

    /*
     * Output html without characters escaping.
     * You can do the same by using triple brackets {{{"some html string here"}}}, but
     * "html" keyword is more obvious and easy to understand and cannot by just a typo.
     * Also it treat null and undefined as empty string, so won't cause errors in
     * SafeString.toString() method.
     */
    return function (value) {
        return new Handlebars.SafeString(value || '');
    };
});

